<template>
  <div class="m-t-4">
    <div 
      class="vessel_owners__table_wide bg-white border border-dark-gray rounded-lg"
      :class="{
        'without_trials': !getPermissionsByType('show_accounts_in_all_operations')
      }"
    >
      <div class="bg-blue-dark border-b colspan-1-9 p-2 uppercase text-white rounded-t-lg">Deposit paid/revert</div>

      <div
        class="border-b border-r p-x-2 p-y-2 fz13 fw500 relative"
        :class="{'bg-gray-light text-gray-text ': !chrtrsData.additional_info.is_paid}"
      >
        Deposit paid by Chrts
        <switcher 
          class="switcher_owners-row"
          id="deposit-paid"
          v-model="chrtrsData.additional_info.is_paid"
        />
      </div>
      <div class="border-b border-r" :class="{'bg-gray-light text-gray-text ': !chrtrsData.additional_info.is_paid}" v-if="getPermissionsByType('show_accounts_in_all_operations')">
        <get-trials
          v-if="$route.params.subId"
          trialKey="SUBLET_Deposit Paid by Chrts"
        />
        <get-trials
          v-else
          trialKey="Deposit Paid by Chrts"
        />
      </div>
      <div class="border-b border-r" :class="{'bg-gray-light text-gray-text ': !chrtrsData.additional_info.is_paid}"></div>
      <div class="border-b border-r" :class="{'bg-gray-light text-gray-text ': !chrtrsData.additional_info.is_paid}"></div>
      <div class="border-b border-r" :class="{'bg-gray-light text-gray-text ': !chrtrsData.additional_info.is_paid}">
        <input-format-number
          v-if="chrtrsData.additional_info.trs_type_paid == 'revenues'"
          v-model="chrtrsData.deposit_paid_debit"
          :inputClass="'p-x-2 p-y-2 text-align-right '+(!chrtrsData.additional_info.is_paid?'text-gray-text':'')"
          placeholder="Enter the amount"
          :disabled="!chrtrsData.additional_info.is_paid"
        ></input-format-number>
      </div>
      <div class="border-b border-r" :class="{'bg-gray-light text-gray-text ': !chrtrsData.additional_info.is_paid}">
        <input-format-number
          v-if="chrtrsData.additional_info.trs_type_paid == 'expenses'"
          v-model="chrtrsData.deposit_paid_credit"
          :inputClass="'p-x-2 p-y-2 text-align-right '+(!chrtrsData.additional_info.is_paid?'text-gray-text':'')"
          placeholder="Enter the amount"
          :disabled="!chrtrsData.additional_info.is_paid"
        ></input-format-number>
      </div>
      <div class="border-b border-r">
        <trs-type-btn
          :additional="chrtrsData.additional_info"
          type="trs_type_paid"
          active="revenues"
        />
      </div>
      <div class="border-b">
        <trs-type-btn
          :additional="chrtrsData.additional_info"
          type="trs_type_paid"
          active="expenses"
        />
      </div>

      <div
        class="border-r p-x-2 p-y-2 fz13 fw500 relative"
        :class="{'bg-gray-light text-gray-text ': !chrtrsData.additional_info.is_revert}"
      >
        Deposit revert to Chrts
        <switcher 
          class="switcher_owners-row"
          id="deposit-revert"
          v-model="chrtrsData.additional_info.is_revert"
        />
      </div>
      <div class="border-r" :class="{'bg-gray-light text-gray-text ': !chrtrsData.additional_info.is_revert}" v-if="getPermissionsByType('show_accounts_in_all_operations')">
        <get-trials
          v-if="$route.params.subId"
          trialKey="SUBLET_Deposit Revert to Chrts"
        />
        <get-trials
          v-else
          trialKey="Deposit Revert to Chrts"
        />
      </div>
      <div class="border-r" :class="{'bg-gray-light text-gray-text ': !chrtrsData.additional_info.is_revert}"></div>
      <div class="border-r" :class="{'bg-gray-light text-gray-text ': !chrtrsData.additional_info.is_revert}"></div>
      <div class="border-r" :class="{'bg-gray-light text-gray-text ': !chrtrsData.additional_info.is_revert}">
        <input-format-number
          v-if="chrtrsData.additional_info.trs_type_revert == 'revenues'"
          v-model="chrtrsData.deposit_revert_debit"
          :inputClass="'p-x-2 p-y-2 text-align-right '+(!chrtrsData.additional_info.is_revert?'text-gray-text':'')"
          placeholder="Enter the amount"
          :disabled="!chrtrsData.additional_info.is_revert"
        ></input-format-number>
      </div>
      <div class="border-r" :class="{'bg-gray-light text-gray-text ': !chrtrsData.additional_info.is_revert}">
        <input-format-number
          v-if="chrtrsData.additional_info.trs_type_revert == 'expenses'"
          v-model="chrtrsData.deposit_revert_credit"
          :inputClass="'p-x-2 p-y-2 text-align-right '+(!chrtrsData.additional_info.is_revert?'text-gray-text':'')"
          placeholder="Enter the amount"
          :disabled="!chrtrsData.additional_info.is_revert"
        ></input-format-number>
      </div>
      <div class="border-r">
        <trs-type-btn
          :additional="chrtrsData.additional_info"
          type="trs_type_revert"
          active="revenues"
        />
      </div>
      <div class="">
        <trs-type-btn
          :additional="chrtrsData.additional_info"
          type="trs_type_revert"
          active="expenses"
        />
      </div>
    </div>

    <button
      type="button"
      class="m-t-2 flex items-center cursor-pointer text-blue-dark fw500 fz13"
      @click="$emit('on-delete', 'deposit')"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.6364 4.36585C10.5073 4.36585 10.4091 4.46907 10.4091 4.58852V5.26399H13.5909V4.58852C13.5909 4.46907 13.4927 4.36585 13.3636 4.36585L10.6364 4.36585ZM14.9545 5.26399V4.58852C14.9545 3.70768 14.2387 3 13.3636 3L10.6364 3C9.76125 3 9.04545 3.70768 9.04545 4.58852V5.26399H5.18182C4.80526 5.26399 4.5 5.56975 4.5 5.94692C4.5 6.32409 4.80526 6.62984 5.18182 6.62984H6.31818V16.5059C6.31818 17.8869 7.441 19 8.81818 19H15.1818C16.559 19 17.6818 17.8869 17.6818 16.5059V6.62984H18.8182C19.1947 6.62984 19.5 6.32409 19.5 5.94692C19.5 5.56975 19.1947 5.26399 18.8182 5.26399H14.9545ZM7.68182 6.62984V16.5059C7.68182 17.1255 8.18706 17.6341 8.81818 17.6341H15.1818C15.8129 17.6341 16.3182 17.1255 16.3182 16.5059V6.62984H7.68182ZM10.6364 8.88637C11.0129 8.88637 11.3182 9.19213 11.3182 9.5693V14.5501C11.3182 14.9272 11.0129 15.233 10.6364 15.233C10.2598 15.233 9.95455 14.9272 9.95455 14.5501V9.5693C9.95455 9.19213 10.2598 8.88637 10.6364 8.88637ZM13.3636 8.88637C13.7402 8.88637 14.0455 9.19213 14.0455 9.5693V14.5501C14.0455 14.9272 13.7402 15.233 13.3636 15.233C12.9871 15.233 12.6818 14.9272 12.6818 14.5501V9.5693C12.6818 9.19213 12.9871 8.88637 13.3636 8.88637Z"
          fill="#094172"
        />
      </svg>
      Delete Deposit Paid by Chrts / Revert to Chrts Section
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import getTrials from '@/components/vessels/owners/edit/getTrials'
import trsTypeBtn from '@/components/vessels/owners/edit/trsTypeBtn'
import inputFormatNumber from '@/components/reuse/inputFormatNumber'
import Switcher from '@/components/reuse/switcher.vue'

export default {
  props: {
    chrtrsData: Object
  },
  components: {
    getTrials,
    trsTypeBtn,
    inputFormatNumber,
    Switcher
  },
  watch: {
    'chrtrsData.additional_info.trs_type_paid': function() {this.changeTRS('paid')},
    'chrtrsData.additional_info.trs_type_revert': function() {this.changeTRS('revert')},
  },
  computed: {
    ...mapGetters(["getPermissionsByType"])
  },
  methods: {
    changeTRS(type) {
      if(type == 'paid'){
        if(this.chrtrsData.additional_info.trs_type_paid == 'revenues'){
          this.chrtrsData.deposit_paid_debit = this.chrtrsData.deposit_paid_credit
          this.chrtrsData.deposit_paid_credit = ''
        }else{
          this.chrtrsData.deposit_paid_credit = this.chrtrsData.deposit_paid_debit
          this.chrtrsData.deposit_paid_debit = ''
        }
      }else{
        if(this.chrtrsData.additional_info.trs_type_revert == 'revenues'){
          this.chrtrsData.deposit_revert_debit = this.chrtrsData.deposit_revert_credit
          this.chrtrsData.deposit_revert_credit = ''
        }else{
          this.chrtrsData.deposit_revert_credit = this.chrtrsData.deposit_revert_debit
          this.chrtrsData.deposit_revert_debit = ''
        }
      }
    },
    checkIsRow() {
      if(!Object.prototype.hasOwnProperty.call(this.chrtrsData.additional_info, 'is_paid')){
        this.$set(this.chrtrsData.additional_info, 'is_paid', true)
      }
      if(!Object.prototype.hasOwnProperty.call(this.chrtrsData.additional_info, 'is_revert')){
        this.$set(this.chrtrsData.additional_info, 'is_revert', true)
      }
    }
  },
  mounted() {
    this.checkIsRow()
  }
}
</script>

<style>
</style>